module.exports = __webpack_public_path__ + "img/益视说明书_14.7a5d3341.png";